/**
 * Skogstad Sport – produktgalleri
 * ------------------------------------------------------------------
 * Et vanlig galleri, ikke en bildestabel:
 *
 *   DESKTOP  ETT stort hovedbilde, med miniatyrskinnen i en rad under.
 *            Klikk på en miniatyr bytter hovedbildet; pilene blar.
 *   MOBIL    samme bilder som et swipe-galleri med scroll-snap og teller.
 *   ZOOM     klikk på hovedbildet åpner lightboxen, som viser bildene TO OG
 *            TO i bredden og ruller til det du klikket. Da ser du forsiden
 *            og baksiden samtidig i stedet for å bla mellom dem.
 *
 * FARGE STYRER BILDENE
 * Katalogen kobler bilde til farge på to måter, og Liquid har allerede
 * bestemt hvilken som gjelder («data-sk-sett-modus»):
 *
 *   alt  Impulses bildesett-konvensjon — alt-teksten «#Farge_Gardenia».
 *        Nøkkelen er fargenavnet.
 *   sku  Trimit-syncen. Alt-teksten er filnavnet «03-022017_452_studio2.jpg»,
 *        og nøkkelen er artikkelnummer + fargekode — de ni første tegnene i
 *        variantens SKU. Se snippets/skogstad-bildesett.liquid.
 *
 * Nøkkelen for BILDENE regnes ut i Liquid, nøkkelen for VARIANTEN i
 * `nokkelFor` under. De to må gi samme svar for samme farge; endres den ene,
 * må den andre endres samtidig.
 *
 * Finnes ingen av delene, filtrerer vi ikke — vi skjuler aldri alt og står
 * igjen med et tomt galleri.
 *
 * Ingen avhengigheter, ingen Flickity, ingen PhotoSwipe.
 */
(function () {
  'use strict';

  var MOBIL = '(max-width: 768px)';

  function erMobil() {
    return window.matchMedia(MOBIL).matches;
  }

  function normaliser(verdi) {
    return String(verdi == null ? '' : verdi).toLowerCase().trim();
  }

  /* ================================================================
     Galleri
     ================================================================ */
  function Galleri(rot) {
    this.rot = rot;
    this.scene = rot.querySelector('[data-sk-grid]');
    if (!this.scene) return;

    this.celler = Array.prototype.slice.call(rot.querySelectorAll('[data-sk-celle]'));
    this.skinneElementer = Array.prototype.slice.call(rot.querySelectorAll('[data-sk-skinne-element]'));
    this.miniatyrer = Array.prototype.slice.call(rot.querySelectorAll('[data-sk-miniatyr]'));
    this.tellerNaa = rot.querySelector('[data-sk-teller-naa]');
    this.tellerSum = rot.querySelector('[data-sk-teller-sum]');
    this.forrigeKnapp = rot.querySelector('[data-sk-hoved-forrige]');
    this.nesteKnapp = rot.querySelector('[data-sk-hoved-neste]');

    this.fargeIndeks = rot.dataset.skFargeIndeks || '';
    this.settModus = rot.dataset.skSettModus || '';
    this.fargeStart = rot.dataset.skFargeStart || '';
    this.seksjonId = rot.dataset.skSeksjon || '';

    this.synlige = this.celler.slice();
    this.aktiv = this.celler[0] || null;

    this.bindHendelser();
    this.visCelle(this.aktiv, true);

    // Første farge – varianten som er valgt ved sidelast. Liquid har regnet
    // ut nøkkelen for nettopp den varianten, så vi slipper å lete etter en
    // :checked-input som kanskje ikke er skrevet ut ennå.
    if (this.settModus && this.fargeStart) {
      this.filtrerPaaFarge(this.fargeStart);
    }
  }

  Galleri.prototype.bindHendelser = function () {
    var self = this;

    this.miniatyrer.forEach(function (knapp) {
      knapp.addEventListener('click', function () {
        self.visCelle(self.finnCelle(parseInt(knapp.dataset.skIndeks, 10)));
      });
    });

    if (this.forrigeKnapp) {
      this.forrigeKnapp.addEventListener('click', function () { self.bla(-1); });
    }
    if (this.nesteKnapp) {
      this.nesteKnapp.addEventListener('click', function () { self.bla(1); });
    }

    // Fargebytte. theme.js sender 'variant:change' på document.
    // isConnected-sjekken lar en instans som er koblet fra DOM-en (theme
    // editor rendrer seksjonen på nytt) trekke seg ut i stedet for å jobbe
    // mot døde noder.
    document.addEventListener('variant:change', function (evt) {
      if (!self.rot.isConnected) return;
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      if (self.settModus) {
        self.filtrerPaaFarge(self.nokkelFor(variant));
        return;
      }
      // Uten bildesett filtrerer vi ikke — da viser vi variantens eget bilde.
      if (variant.featured_media) {
        var celle = self.scene.querySelector('[data-sk-media-id="' + variant.featured_media.id + '"]');
        if (celle) self.visCelle(celle);
      }
    });

    var tidsavbrudd;
    this.scene.addEventListener(
      'scroll',
      function () {
        if (!erMobil()) return;
        window.clearTimeout(tidsavbrudd);
        tidsavbrudd = window.setTimeout(function () { self.lesMobilPosisjon(); }, 80);
      },
      { passive: true }
    );
  };

  Galleri.prototype.finnCelle = function (indeks) {
    for (var i = 0; i < this.celler.length; i++) {
      if (parseInt(this.celler[i].dataset.skIndeks, 10) === indeks) return this.celler[i];
    }
    return null;
  };

  /**
   * Nøkkelen som knytter EN VARIANT til bildene sine. Speiler
   * snippets/skogstad-bildesett.liquid, som regner ut den samme nøkkelen for
   * bildene. Er SKU-en kortere enn ni tegn har vi ingenting å matche på, og
   * svarer tomt — da filtrerer vi ikke.
   */
  Galleri.prototype.nokkelFor = function (variant) {
    if (this.settModus === 'sku') {
      var sku = variant && variant.sku ? String(variant.sku) : '';
      return sku.length >= 9 ? sku.slice(0, 9).toLowerCase() : '';
    }
    return this.fargeIndeks ? variant[this.fargeIndeks] : '';
  };

  /**
   * Skjuler cellene som hører til en annen farge. To ting holdes fra
   * hverandre her:
   *
   *   Har fargen egne bilder i det hele tatt? Har den ikke det — plagget
   *   finnes i fire farger, men bare to av dem er fotografert — filtrerer vi
   *   ikke. Et tomt galleri er verre enn et upresist galleri.
   *
   *   Umerkede bilder (miljøbilder og detaljer uten fargekode i filnavnet)
   *   hører til ALLE farger og blir stående. Skinnen har alltid behandlet dem
   *   slik; cellene gjorde det ikke, og et miljøbilde forsvant derfor fra
   *   hovedbildet mens miniatyren av det ble stående og pekte på ingenting.
   */
  Galleri.prototype.filtrerPaaFarge = function (fargeverdi) {
    var maal = normaliser(fargeverdi);
    if (!maal) return;

    var harEgne = this.celler.some(function (celle) {
      return celle.dataset.skFarge === maal;
    });

    var treff = harEgne
      ? this.celler.filter(function (celle) {
          return !celle.dataset.skFarge || celle.dataset.skFarge === maal;
        })
      : this.celler.slice();

    this.celler.forEach(function (celle) {
      celle.hidden = treff.indexOf(celle) === -1;
    });
    this.skinneElementer.forEach(function (element) {
      var egen = element.dataset.skFarge;
      element.hidden = harEgne && !!egen && egen !== maal;
    });

    this.synlige = treff;

    // Åpne på et bilde AV fargen, ikke på et miljøbilde som tilfeldigvis
    // ligger først i rekka.
    var forste = null;
    for (var i = 0; i < treff.length; i++) {
      if (treff[i].dataset.skFarge === maal) { forste = treff[i]; break; }
    }
    this.visCelle(forste || treff[0], true);

    if (erMobil() && this.scene.scrollTo) {
      this.scene.scrollTo({ left: 0, behavior: 'auto' });
    }
  };

  /** Gjør én celle til hovedbildet (desktop) eller ruller til den (mobil). */
  Galleri.prototype.visCelle = function (celle, umiddelbart) {
    if (!celle) return;
    this.aktiv = celle;

    this.celler.forEach(function (c) {
      c.classList.toggle('is-aktiv', c === celle);
    });

    var indeks = parseInt(celle.dataset.skIndeks, 10);
    this.skinneElementer.forEach(function (element) {
      var egen = parseInt(element.dataset.skIndeks, 10);
      var aktiv = egen === indeks;
      element.classList.toggle('is-aktiv', aktiv);
      var knapp = element.querySelector('[data-sk-miniatyr]');
      if (knapp) knapp.setAttribute('aria-current', aktiv ? 'true' : 'false');
    });

    if (erMobil()) {
      var posisjon = this.synlige.indexOf(celle);
      if (posisjon > -1 && this.scene.scrollTo) {
        this.scene.scrollTo({
          left: posisjon * this.scene.clientWidth,
          behavior: umiddelbart ? 'auto' : 'smooth'
        });
      }
    }

    this.oppdaterTeller();
    this.oppdaterPiler();
  };

  Galleri.prototype.bla = function (retning) {
    var posisjon = this.synlige.indexOf(this.aktiv);
    if (posisjon < 0) posisjon = 0;
    var ny = posisjon + retning;
    if (ny < 0 || ny >= this.synlige.length) return;
    this.visCelle(this.synlige[ny]);
  };

  /* Pilene skjules i endene i stedet for å gå i ring. Et produktgalleri har
     en begynnelse og en slutt, og en pil som ikke gjør noe er verre enn
     ingen pil. */
  Galleri.prototype.oppdaterPiler = function () {
    if (!this.forrigeKnapp || !this.nesteKnapp) return;
    var posisjon = this.synlige.indexOf(this.aktiv);
    var flere = this.synlige.length > 1;
    this.forrigeKnapp.hidden = !flere || posisjon <= 0;
    this.nesteKnapp.hidden = !flere || posisjon >= this.synlige.length - 1;
  };

  Galleri.prototype.oppdaterTeller = function () {
    if (!this.tellerNaa) return;
    var posisjon = this.synlige.indexOf(this.aktiv);
    this.tellerNaa.textContent = String(posisjon < 0 ? 1 : posisjon + 1);
    if (this.tellerSum) this.tellerSum.textContent = String(this.synlige.length);
  };

  Galleri.prototype.lesMobilPosisjon = function () {
    var bredde = this.scene.clientWidth || 1;
    var posisjon = Math.round(this.scene.scrollLeft / bredde);
    var celle = this.synlige[Math.min(posisjon, this.synlige.length - 1)];
    if (!celle || celle === this.aktiv) return;
    // Ikke rull tilbake til seg selv: bare oppdater markeringen.
    this.aktiv = celle;
    var indeks = parseInt(celle.dataset.skIndeks, 10);
    this.skinneElementer.forEach(function (element) {
      element.classList.toggle('is-aktiv', parseInt(element.dataset.skIndeks, 10) === indeks);
    });
    this.oppdaterTeller();
    this.oppdaterPiler();
  };

  /* ================================================================
     Lightbox – to bilder i bredden
     ================================================================ */
  function Lightbox(rot, galleri) {
    this.rot = rot;
    this.galleri = galleri;
    this.scene = rot.querySelector('[data-sk-scene]');
    this.teller = rot.querySelector('[data-sk-lightbox-teller]');
    this.data = [];
    this.sisteFokus = null;

    var script = document.querySelector('[data-sk-galleri-data="' + galleri.seksjonId + '"]');
    if (script) {
      try { this.data = JSON.parse(script.textContent); } catch (e) { this.data = []; }
    }

    this.bind();
  }

  Lightbox.prototype.bind = function () {
    var self = this;

    this.galleri.rot.querySelectorAll('[data-sk-apne]').forEach(function (knapp) {
      knapp.addEventListener('click', function () {
        self.apne(parseInt(knapp.dataset.skIndeks, 10));
      });
    });

    this.rot.querySelectorAll('[data-sk-lukk]').forEach(function (el) {
      el.addEventListener('click', function () { self.lukk(); });
    });

    document.addEventListener('keydown', function (evt) {
      if (!self.rot.isConnected || self.rot.hidden) return;
      if (evt.key === 'Escape') {
        evt.preventDefault();
        self.lukk();
      } else if (evt.key === 'ArrowRight' || evt.key === 'ArrowDown') {
        evt.preventDefault();
        self.rull(1);
      } else if (evt.key === 'ArrowLeft' || evt.key === 'ArrowUp') {
        evt.preventDefault();
        self.rull(-1);
      } else if (evt.key === 'Tab') {
        self.fangFokus(evt);
      }
    });

    var tidsavbrudd;
    this.scene.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(tidsavbrudd);
        tidsavbrudd = window.setTimeout(function () { self.oppdaterTeller(); }, 80);
      },
      { passive: true }
    );
  };

  /** Indeksene som er synlige akkurat nå – lightboxen følger fargevalget. */
  Lightbox.prototype.rekkefolge = function () {
    return this.galleri.synlige.map(function (celle) {
      return parseInt(celle.dataset.skIndeks, 10);
    });
  };

  Lightbox.prototype.apne = function (indeks) {
    this.sisteFokus = document.activeElement;
    this.rot.hidden = false;
    this.rot.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sk-lightbox-apen');
    this.bygg(indeks);
    var lukk = this.rot.querySelector('.sk-lightbox__lukk');
    if (lukk) lukk.focus();
  };

  Lightbox.prototype.lukk = function () {
    this.rot.hidden = true;
    this.rot.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sk-lightbox-apen');
    this.scene.innerHTML = '';
    if (this.sisteFokus && this.sisteFokus.focus) this.sisteFokus.focus();
  };

  /**
   * Bygger hele bildesettet én gang og ruller til det kunden klikket.
   * Full oppløsning lastes først her — aldri på selve produktsiden.
   */
  Lightbox.prototype.bygg = function (startIndeks) {
    var self = this;
    var rekke = this.rekkefolge();
    this.scene.innerHTML = '';
    this.figurer = [];

    rekke.forEach(function (indeks) {
      var post = self.data[indeks];
      if (!post) return;

      var figur = document.createElement('figure');
      figur.className = 'sk-lightbox__figur';
      figur.dataset.skIndeks = String(indeks);

      var vis;
      if (post.type === 'external_video' && post.innbygd) {
        vis = document.createElement('iframe');
        vis.className = 'sk-lightbox__video';
        vis.setAttribute('allow', 'autoplay; fullscreen');
        vis.setAttribute('allowfullscreen', '');
        vis.src = post.vert === 'vimeo'
          ? 'https://player.vimeo.com/video/' + post.innbygd
          : 'https://www.youtube.com/embed/' + post.innbygd + '?rel=0';
      } else if (post.type === 'video' && post.kilder && post.kilder.length) {
        vis = document.createElement('video');
        vis.className = 'sk-lightbox__video';
        vis.controls = true;
        vis.playsInline = true;
        post.kilder.forEach(function (kilde) {
          var kilde_el = document.createElement('source');
          kilde_el.src = kilde.url;
          kilde_el.type = kilde.mime;
          vis.appendChild(kilde_el);
        });
      } else {
        vis = document.createElement('img');
        vis.className = 'sk-lightbox__bilde';
        vis.src = post.url;
        vis.alt = post.alt || '';
        vis.width = post.bredde;
        vis.height = post.hoyde;
        vis.draggable = false;
        vis.tabIndex = 0;
        vis.setAttribute('role', 'button');
        vis.addEventListener('click', function (evt) {
          var rekt = vis.getBoundingClientRect();
          self.vekslZoom(vis, (evt.clientX - rekt.left) / rekt.width, (evt.clientY - rekt.top) / rekt.height);
        });
        vis.addEventListener('keydown', function (evt) {
          if (evt.key === 'Enter' || evt.key === ' ') {
            evt.preventDefault();
            self.vekslZoom(vis, 0.5, 0.5);
          }
        });
      }

      figur.appendChild(vis);
      self.scene.appendChild(figur);
      self.figurer.push(figur);
    });

    // Rull til bildet kunden klikket, uten animasjon: det skal allerede stå
    // der når lightboxen dukker opp.
    var maal = this.figurer.filter(function (f) {
      return parseInt(f.dataset.skIndeks, 10) === startIndeks;
    })[0];
    if (maal) {
      this.scene.scrollTop = maal.offsetTop - this.scene.offsetTop;
    }
    this.oppdaterTeller();
  };

  /**
   * Piltastene blar RADVIS, ikke bildevis. På desktop står to bilder på
   * samme rad, og «neste bilde» ville da ikke flyttet visningen i det hele
   * tatt annenhver gang.
   */
  Lightbox.prototype.rull = function (retning) {
    var rader = this.rader();
    if (rader.length < 2) return;
    var naa = this.naavaerendeRad(rader);
    var ny = Math.min(Math.max(naa + retning, 0), rader.length - 1);
    this.scene.scrollTo({ top: rader[ny], behavior: 'smooth' });
  };

  /** De unike y-posisjonene figurene ligger på, altså radene. */
  Lightbox.prototype.rader = function () {
    if (!this.figurer || !this.figurer.length) return [];
    var sett = [];
    this.figurer.forEach(function (f) {
      var y = f.offsetTop;
      if (sett.indexOf(y) === -1) sett.push(y);
    });
    var topp = this.scene.offsetTop;
    return sett.sort(function (a, b) { return a - b; }).map(function (y) { return y - topp; });
  };

  Lightbox.prototype.naavaerendeRad = function (rader) {
    var topp = this.scene.scrollTop;
    var beste = 0;
    var minste = Infinity;
    for (var i = 0; i < rader.length; i++) {
      var avstand = Math.abs(rader[i] - topp);
      if (avstand < minste) { minste = avstand; beste = i; }
    }
    return beste;
  };

  /* Antallet, ikke en posisjon: alle bildene er synlige i rutenettet, så en
     «2 av 7» ville svart på et spørsmål kunden ikke har. */
  Lightbox.prototype.oppdaterTeller = function () {
    if (!this.teller || !this.figurer) return;
    var sum = this.figurer.length;
    var suffiks = this.teller.dataset.skSuffiks || '';
    this.teller.textContent = sum > 1 ? sum + ' ' + suffiks : '';
  };

  Lightbox.prototype.vekslZoom = function (bilde, x, y) {
    var zoomet = bilde.classList.toggle('is-zoomet');
    bilde.style.transformOrigin = x * 100 + '% ' + y * 100 + '%';
    bilde.style.transform = zoomet ? 'scale(2)' : '';
  };

  Lightbox.prototype.fangFokus = function (evt) {
    var felt = this.rot.querySelectorAll('button:not([hidden]), [tabindex="0"]');
    if (!felt.length) return;
    var forste = felt[0];
    var siste = felt[felt.length - 1];
    if (evt.shiftKey && document.activeElement === forste) {
      evt.preventDefault();
      siste.focus();
    } else if (!evt.shiftKey && document.activeElement === siste) {
      evt.preventDefault();
      forste.focus();
    }
  };

  /* ================================================================
     Oppstart
     ================================================================ */
  function start() {
    document.querySelectorAll('[data-sk-galleri]').forEach(function (rot) {
      if (rot.dataset.skKlar === 'true') return;
      rot.dataset.skKlar = 'true';
      var galleri = new Galleri(rot);
      if (!galleri.scene) return;
      var boks =
        document.querySelector('[data-sk-lightbox="' + galleri.seksjonId + '"]') ||
        document.querySelector('[data-sk-lightbox]');
      if (boks && rot.dataset.skZoom === 'true') {
        new Lightbox(boks, galleri);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
